export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.28049 4.37524L13.7802 9.99994L9.28049 15.6246L7.71875 14.3752L11.219 9.99994L7.71875 5.62463L9.28049 4.37524Z"/>
  `,
  title: 'Chrevron Right',
  viewBox: '0 0 21 20',
};

